module.exports = __webpack_public_path__ + "static/media/fondo.304826bf.png";